module.exports = __webpack_public_path__ + "img/ios6.164dbc6f.png";